import { useState, useEffect } from "react";
import { useLocation } from "react-router-dom";
import { useTheme } from "../context/ThemeContext";
import Sidebar from "./Sidebar";
import RightSidebar from "./RightSidebar";
import { Menu, X } from "lucide-react";

export default function Layout({
  children,
  rightSidebar,
  showFloatingMenu = false,
  hideRightSidebar = false,
  compactSidebar = false,
}) {
  const { isDark } = useTheme();
  const location = useLocation();
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  const toggleMobileMenu = () => {
    setIsMobileMenuOpen(!isMobileMenuOpen);
  };

  const closeMobileMenu = () => {
    setIsMobileMenuOpen(false);
  };

  // Close menu on route change or when clicking outside
  useEffect(() => {
    if (isMobileMenuOpen) {
      // Prevent body scroll when menu is open
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "unset";
    }

    return () => {
      document.body.style.overflow = "unset";
    };
  }, [isMobileMenuOpen]);

  // Close menu on route change
  useEffect(() => {
    closeMobileMenu();
  }, [location.pathname]);

  return (
    <div
      className={`w-full min-h-screen ${isDark ? "bg-background-dark" : "bg-background"}`}
    >
      {/* Three Column Layout */}
      <div className="flex min-h-screen max-w-layout mx-auto relative">
        {/* Left Sidebar - Desktop */}
        <div className="hidden lg:block">
          <Sidebar compact={compactSidebar} />
        </div>

        {/* Mobile Sidebar Backdrop */}
        {isMobileMenuOpen && (
          <div
            className="fixed inset-0 bg-black/50 z-30 lg:hidden"
            onClick={closeMobileMenu}
            aria-hidden="true"
          />
        )}

        {/* Left Sidebar - Mobile */}
        <div
          className={`${
            isMobileMenuOpen ? "translate-x-0" : "-translate-x-full"
          } lg:hidden fixed inset-y-0 left-0 z-40 transition-transform duration-300 w-64`}
        >
          <Sidebar isMobile={true} closeMobileMenu={closeMobileMenu} />
        </div>

        {/* Main Content */}
        <main
          className={`flex-1 overflow-y-auto min-h-screen ${isDark ? "bg-background-dark" : ""} w-full lg:w-auto relative z-10`}
        >
          {/* Pass toggle function to children */}
          {typeof children === "function"
            ? children({ toggleMobileMenu, isMobileMenuOpen })
            : children}
        </main>

        {/* Right Sidebar - Custom or Default */}
        {!hideRightSidebar && (
          <div className="hidden xl:block">
            {rightSidebar || <RightSidebar />}
          </div>
        )}
      </div>
    </div>
  );
}
